<div class="header-container">
    <div class="header-container__background" [ngClass]="{'expanded': expanded }"></div>
    <div class="header-container__bar">
        <div class="header-container__bar__app" (click)="goHome()">
            <img src="assets/icons/favicon-2.png">
            {{ 'header.title' | transloco }}
        </div>
        <div class="header-container__bar__right-section">
            <app-navigator></app-navigator>
            <app-top-menu></app-top-menu>
        </div>
    </div>
    <div class="header-container__content" [ngClass]="{'hidden': !expanded }">
        <div class="header-container__content__logo"></div>
    </div>
</div>
